import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getReviews, updateReview } from '../api/apiendpoint';

const EditReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [review, setReview] = useState({ title: '', rating: '', content: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const allReviews = await getReviews();
        const selected = allReviews.find((r) => r.id === parseInt(id));
        if (selected) setReview(selected);
        else alert('Review not found');
      } catch (error) {
        console.error(error);
      }
    };
    fetchReview();
  }, [id]);

  const handleChange = (e) => {
    setReview((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateReview(id, review);
      navigate('/'); // or to /reviews
    } catch (err) {
      alert('Update failed');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <h2>Edit Review</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Title:</label>
          <input
            name="title"
            className="form-control"
            value={review.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label>Rating (1–5):</label>
          <input
            name="rating"
            type="number"
            className="form-control"
            value={review.rating}
            onChange={handleChange}
            min="1"
            max="5"
            required
          />
        </div>
        <div className="mb-3">
          <label>Comment:</label>
          <textarea
            name="content"
            className="form-control"
            value={review.content}
            onChange={handleChange}
            required
          />
        </div>
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Saving...' : 'Save Review'}
        </button>
      </form>
    </div>
  );
};

export default EditReview;
